<script>
import AmsuScholarshipCard from "../AmsuScholarshipCard.vue";
import _ from "lodash";
import {mapActions} from "vuex";

export default {
  name: "TheMeetingVoteCommentAchTypeCard",

  components: {AmsuScholarshipCard},

  props: {
    statement: Object,
    comment: {
      type: Object,
      default: {},
    }
  },

  data() {
    return {
      loadingVote: false,
    };
  },

  computed: {

    sizePositiveVoteComment() {
      if(!_.isNil(this.comment)) {
        return _.filter(this.comment.comment_votes, vote => vote.payload.status)?.length || 0
      }
    },

    sizeNegativeVoteComment() {
      if(!_.isNil(this.comment)) {
        return _.filter(this.comment.comment_votes, vote => !vote.payload.status)?.length || 0
      }
    },

    idReviewer() {
      if (_.isEmpty(this.statement) || _.isNil(this.comment)) return null;
      return this.statement.reviewer.id
    },

    checkPositiveVote() {
      if (_.isEmpty(this.statement) || _.isNil(this.comment)) return true;
      return !_.isNil(
        _.find(this.comment.comment_votes, vote => vote.person_id === this.idReviewer && vote.payload.status)
      );
    },

    checkNegativeVote() {
      if (_.isEmpty(this.statement) || _.isNil(this.comment)) return true;

      return !_.isNil(
        _.find(this.comment.comment_votes, vote => vote.person_id === this.idReviewer && !vote.payload.status)
      );
    },
  },

  methods: {
    ...mapActions({
      addVoteComment: 'scholarship_comment/addVoteComment',
      updateVoteComment: 'scholarship_comment/updateVoteComment',
      getStatements: 'scholarship_competition/getStatements',
    }),

    async voteBtnAction({idComment, status}) {
      this.loadingVote = true;

      if (this.checkPositiveVote || this.checkNegativeVote) {
        const vote = _.find(this.comment.comment_votes, vote => vote.person_id === this.idReviewer);
        await this.updateVoteComment({
          idComment: idComment,
          idVote: vote.id
        })
      }
      else {
        await this.addVoteComment({idComment: idComment, status: status})
      }

      await this.getStatements();

      return this.loadingVote = false;
    },
  },

}
</script>

<template>
  <amsu-scholarship-card>
    <v-card-title>
      Комментарий к заявлению

      <v-spacer/>
      <v-icon color="error">
        fa-exclamation
      </v-icon>
    </v-card-title>
    <v-divider/>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title style="max-height: 15vh" class="d-flex text-wrap text-justify overflow-y-auto">
            {{comment.comment_text}}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-icon small left>fa-comment</v-icon> {{comment.person}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        small
        :disabled="checkPositiveVote"
        :loading="loadingVote"
        @click="voteBtnAction({
          status: true,
          idComment: comment.id
        })"
        color="teal darken-3"
        class="white--text rounded-xl"
      >
        {{sizePositiveVoteComment}} <v-divider class="mx-2" vertical/> За
      </v-btn>
      <div class="mx-3"></div>
      <v-btn
        small
        :loading="loadingVote"
        :disabled="checkNegativeVote"
        @click="voteBtnAction({
          status: false,
          idComment: comment.id
        })"
        color="teal darken-3"
        class="white--text rounded-xl"
      >
        {{sizeNegativeVoteComment}} <v-divider class="mx-2" vertical/> Против
      </v-btn>
    </v-card-actions>
  </amsu-scholarship-card>
</template>

<style scoped>

</style>